import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useActivitiesStore } from '@/store/activities';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/activities/activities.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import Calendar from '@/components/views/calendar/Container.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

import { useLayoutField } from '@/composables/useLayoutField';


export default /*@__PURE__*/_defineComponent({
  __name: 'Activities',
  setup(__props) {

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();
const activitiesStore = useActivitiesStore();

const currentView = useLayoutField(moduleName, 'currentView');

const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => activitiesStore.fetchActivities(params),
  {
    create: activitiesStore.createActivity,
    update: (data) => activitiesStore.updateActivity(data.id, data),
    remove: activitiesStore.deleteActivity,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => activitiesStore.activities);


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ViewsContainer, {
        moduleName: _unref(moduleName),
        listViewComponent: Table,
        calendarViewComponent: Calendar,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/activities/activities.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        show_toolbar: true,
        show_pagination: _unref(currentView)!='calendar',
        title: {singular:'Actividad', plural:'Actividades'}
      }, null, 8, ["moduleName", "data", "onCreate", "onUpdate", "onDelete", "show_pagination"])
    ]),
    _: 1
  }))
}
}

})